import React from "react";
import { Flex, Text, Input } from "@chakra-ui/react";
import Heading from "../Text/Heading";

const inputTextStyle = {
  width: "100%",
  height: "38px",
  border: "1px solid #ECEFF9",
  borderRadius: "4px",
  fontWeight: "700",
  fontSize: "13px",
  lineHeight: "22px",
  color: "#0E3665",
  fontFamily: "Nunito",
  marginTop: "8px",
  backgroundColor: "#D9D9D933",
};

const Form = ({
  formData,
  errors,
  handleFormChange,
  disabled,
  updateBooking,
  displayedUIForm,
}) => {
  const smallUppercaseWithletterSpace = {
    fontWeight: "800",
    fontSize: displayedUIForm ? "8px" : "14px",
    lineHeight: "1.5",
    color: displayedUIForm ? "#0E3665" : "#000000",
    fontFamily: displayedUIForm ? "Nunito" : "Proxima Nova",
    textTransform: displayedUIForm ? "uppercase" : "none",
    letterSpacing: displayedUIForm ? "2px" : "0px",
  };
  return (
    <Flex flexDirection={"column"} width={"92.92%"} minheight={"330px"}>
      {updateBooking ? null : <Heading headingLabel="Booking Appointment" />}
      <Text
        {...smallUppercaseWithletterSpace}
        marginTop={displayedUIForm ? "40px" : "30px"}
      >
        First Name
      </Text>
      <Input
        {...inputTextStyle}
        name="customerFirstName"
        value={formData.customerFirstName}
        onChange={handleFormChange}
        disabled={disabled}
      />

      {errors?.customerFirstName && (
        <Text color="red" mt="1" fontSize="12">
          {errors.customerFirstName}
        </Text>
      )}

      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Last Name
      </Text>
      <Input
        {...inputTextStyle}
        name="customerLastName"
        value={formData.customerLastName}
        onChange={handleFormChange}
        disabled={disabled}
      />

      {errors?.customerLastName && (
        <Text color="red" mt="1" fontSize="12">
          {errors.customerLastName}
        </Text>
      )}

      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Phone Number
      </Text>
      <Input
        {...inputTextStyle}
        name="phoneNumber"
        value={formData.phoneNumber}
        onChange={handleFormChange}
        disabled={disabled}
      />

      {errors?.phoneNumber && (
        <Text color="red" mt="1" fontSize="12">
          {errors.phoneNumber}
        </Text>
      )}

      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Email Address
      </Text>
      <Input
        {...inputTextStyle}
        name="emailAddress"
        value={formData.emailAddress}
        onChange={handleFormChange}
        disabled={disabled}
      />

      {errors?.emailAddress && (
        <Text color="red" mt="1" fontSize="12">
          {errors.emailAddress}
        </Text>
      )}
      {displayedUIForm ? (
        Boolean(formData.reference?.trim().length > 0) && (
          <>
            <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
              Reference Number
            </Text>
            <Input {...inputTextStyle} value={formData.reference} disabled />
          </>
        )
      ) : (
        <>
          <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
            Reference (optional)
          </Text>
          <Input
            {...inputTextStyle}
            name="reference"
            value={formData.reference}
            onChange={handleFormChange}
            disabled={disabled}
          />

          {errors?.reference && (
            <Text color="red" mt="1" fontSize="12">
              {errors.reference}
            </Text>
          )}
        </>
      )}
    </Flex>
  );
};

export default Form;
